<template>
  <nav id="nav">
    <div class="burger" @click="toggleNavbar">
      <div class="line line1"></div>
      <div class="line-middle line2"></div>
      <div class="line line3"></div>
    </div>

    <div class="logo">
      <a id="about" href="/">
        <img class="nav-logo" src="../assets/logo.png" />
      </a>
    </div>

    <div class="menu">
      <ul class="left">
        <li id="first" @click="toggleNavbar">
          <a
            v-if="this.$router.currentRoute.name == 'home'"
            v-scroll-to="'#aboutus'"
            >L'entreprise</a
          >
          <a v-else href="/#aboutus">L'entreprise</a>
        </li>
        <li @click="toggleNavbar">
          <a
            v-if="this.$router.currentRoute.name == 'home'"
            v-scroll-to="'#solutions'"
            >Nos solutions</a
          >
          <a v-else href="/#solutions">Nos solutions</a>
        </li>
        <li @click="toggleNavbar">
          <a
            v-if="this.$router.currentRoute.name == 'home'"
            v-scroll-to="'#vergnano'"
            >Caffè Vergnano</a
          >
          <a v-else href="/#vergnano">Caffè Vergnano</a>
        </li>
      </ul>
      <ul class="right">
        <li class="divider"></li>
        <li @click="toggleNavbar">
          <a href="contact">
            <i class="fa fa-shopping-cart"></i>
            Boutique
          </a>
        </li>
        <li @click="toggleNavbar">
          <a href="contact">
            <i class="fa fa-paper-plane-o"></i>
            Contact
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navigation",

  created() {
    window.addEventListener("scroll", this.stickNav);
  },

  methods: {
    toggleNavbar() {
      let menu = document.querySelectorAll("nav ul");
      menu.forEach((ul) => {
        ul.classList.toggle("showing");
      });

      document.querySelector("nav").classList.toggle("black");

      //Burger animation
      const burger = document.querySelector(".burger");
      burger.classList.toggle("toggle");
    },

    closeNavbar() {
      let menu = document.querySelectorAll("nav ul");
      menu.forEach((ul) => {
        ul.classList.remove("showing");
      });

      document.querySelector("nav").classList.remove("black");

      const burger = document.querySelector(".burger");

      if (burger.classList.contains("toggle")) {
        burger.classList.remove("toggle");
      }
    },

    stickNav() {
      if (window.top.scrollY >= window.innerHeight) {
        document.getElementById("nav").style.display = "block";
        document.getElementById("nav").classList.add("fixed-nav");
      } else {
        if (this.$router.currentRoute.name !== "contact") {
          this.closeNavbar();
          document.getElementById("nav").style.display = "none";
          document.getElementById("nav").classList.remove("fixed-nav");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
nav ul li a {
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  transition: transform 0.3s ease-in-out;
}

nav ul li a:hover {
  -webkit-transform: scale(1.15);
  -ms-transform: scale(1.15);
  -moz-transform: scale(1.15);
  transform: scale(1.15);
}

.burger {
  padding-top: 10px;
  line-height: 60px;
  float: right;
  margin: 7px 15px;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 2px;
  max-height: 45px;
}

.logo {
  line-height: 60px;
  position: absolute;
  float: left;
  margin: 16px 46px;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 2px;
  max-width: 10%;
}

li.divider {
  width: 60px;
  height: 2px;
  padding: 0;
  background-color: white;
  margin-left: auto;
  margin-right: auto;
  transition: all 0.3s;
}

.nav-logo {
  width: auto;
  height: 45px;
}

nav {
  z-index: 100;
  position: absolute;
  width: 100%;
  line-height: 60px;
  height: 92px;
}

nav .left {
  line-height: 60px;
  list-style: none;
  background: rgba(0, 0, 0, 0);
  overflow: hidden;
  color: #fff;
  padding: 0 0 0 200px;
  float: left;
  margin: 0;
  transition: 1s;
}

nav .right {
  line-height: 60px;
  list-style: none;
  background: rgba(0, 0, 0, 0);
  overflow: hidden;
  color: #fff;
  padding: 0;
  float: right;
  margin: 0;
  transition: 1s;
}

nav.black ul {
  background: #000;
}

nav ul li {
  display: inline-block;
  padding: 16px 20px;
  transition: transform 0.3s ease-in-out;
}

@media only screen and (max-width: 960px) {
  nav ul li {
    padding: 16px 10px;
  }
}

@media only screen and (min-width: 851px) {
  li.divider {
    display: none;
  }
}

@media only screen and (max-width: 850px) {
  .logo {
    margin: 0px 30px;
    width: unset;
    height: 60px;
    max-width: none;
  }

  .nav-logo {
    height: 35px;
  }

  .fixed-nav {
    height: 60px !important;
  }

  li.divider {
    display: block;
  }

  nav ul {
    max-height: 0px;
    background: #000;
  }

  #first {
    padding-top: 30px;
  }

  nav .left {
    padding: 0;
    float: none;
    width: 100%;
  }

  nav .right {
    padding: 0;
    float: none;
    width: 100%;
  }

  nav.black ul {
    background: #000;
  }

  .showing {
    max-height: 34em;
  }

  nav ul li {
    box-sizing: border-box;
    width: 100%;
    text-align: center;
    padding: 1% 20px;
  }

  .line {
    width: 25px;
    height: 2px;
    background: #92561d;
    margin: 5px;
    border-radius: 5px;
    transition: all 0.5s ease-in-out;
  }

  .line-middle {
    width: 20px;
    height: 2px;
    background: #92561d;
    margin: 5px;
    border-radius: 5px;
    transition: all 0.5s ease-in-out;
  }
}

.fixed-nav {
  position: fixed !important;
  top: 0;
  width: 100%;
  background-color: black;
  animation: navbarColor 0.3s ease-in-out;
  height: 92px;
}

@keyframes navbarColor {
  from {
    background-color: transparent;
  }
  to {
    background-color: black;
  }
}

@keyframes fadein {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.toggle .line1 {
  transform: rotate(-45deg) translate(-6px, 5px);
}

.toggle .line2 {
  opacity: 0;
  transform: translateX(-50px);
  animation: fadein 0.5s ease-in-out;
}

.toggle .line3 {
  transform: rotate(45deg) translate(-5px, -4px);
}
</style>